<div>
    <h2>Page Not Found</h2>
    @if (failedUrl) {
        <div><strong>Requested URL:</strong> {{ failedUrl }}</div>
    }
    @if (errorMessage) {
        <div><strong>Error:</strong> {{ errorMessage }}</div>
    }
    @if (errorDetails) {
        <div style="margin-top: 8px;">
            <strong>Details:</strong>
            <pre style="white-space: pre-wrap; word-break: break-word;">{{ errorDetails }}</pre>
        </div>
    }
    @if (!failedUrl && !errorMessage && !errorDetails) {
        <div>No navigation diagnostics were provided.</div>
    }
</div>
